import {
    localUrlMapping,
    prodUrlMapping,
    stagingUrlMapping,
    uatUrlMapping,
    qaUrlMapping
} from './url-mapping.constant';

function _window(): any {
    return window;
}

export function getInstitutionId(environment = 'local') {
    const hostname = _window().location.hostname;
    let urlMappings: any[];

    switch (environment.toLowerCase()) {
        case 'prod':
            urlMappings = prodUrlMapping;
            break;
        case 'staging':
            urlMappings = stagingUrlMapping;
            break;
        case 'uat':
            urlMappings = uatUrlMapping;
            break;
        case 'qa':
            urlMappings = qaUrlMapping;
            break;
        default:
            urlMappings = localUrlMapping;
            break;
    }

    let institution = urlMappings.find(item => item.url === hostname);

    if (['local', 'uat', 'qa'].includes(environment.toLowerCase())) {
        const urlParams = new URLSearchParams(window.location.search);
        const institutionId = urlParams.get('institutionId');
        if (institutionId) {
            // finding institution setup from UAT as it will have all institutions setup in it
            institution = uatUrlMapping.find(item => item.institutionId.toLowerCase() === institutionId.toLowerCase());
        }
    }

    return institution || urlMappings.find(item => item.institutionId === 'ABC');
}
